module.exports = __webpack_public_path__ + "img/reaction9.18755528.png";